import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { EstadosTituloViaticos } from 'constants/index'

const EstadoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='ESTADO' htmlFor='input-estado' md={3} alignRightAt='md' />
      <Col md={9}>
        <Field name='estado'>
          {({ field }) => (
            <Form.Select {...field} isInvalid={iTouched && iError} disabled={fIsSubmitting} id='input-estado'>
              <option value=''>Seleccionar</option>
              {EstadosTituloViaticos.__array.map(x => (
                <option key={x.id} value={x.id}>
                  {x.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(EstadoFormGroup)
